export enum Permission {
  ACCESS_DASHBOARD = 'Access Dashboard',
  MANAGE_USERS = 'Manage Users',
  MANAGE_ROLES = 'Manage Roles',
  VIEW_JOBS = 'View Jobs',
  VIEW_LOGGING = 'View Logging',
  VIEW_SERVICES = 'View Services',
  DEVELOPER = 'Developer',
  VIEW_CUSTOMERS = 'View Customers',
  ADD_CUSTOMERS = 'Add Customers',
  MODIFY_CUSTOMERS = 'Modify Customers',
  IMPORT_CUSTOMERS = 'Import Customers',
  MANAGE_SFTP_CREDENTIALS = 'Manage SFTP Credentials',
  VIEW_CUSTOMER_DATA = 'View Customer Data',
  VIEW_PRODUCT_DETAILS = 'View Product Details',
  PROCESS_FEEDS = 'Process Feeds',
  VIEW_SCOUT_FILE = 'View Scout File',
  IMPORT_LEGACY_CURATION_DATA = 'Import Legacy Curation Data',
  MODIFY_PRODUCT_DATA = 'Modify Product Data',
  PUBLISH_PRODUCT_DATA = 'Publish Product Data',
  RECEIVE_UNCURATED_PRODUCT_EMAILS = 'Receive Uncurated Product Emails',
  RECEIVE_STALE_JOB_EMAILS = 'Receive Stale Job Emails',
  DELETE_CURATED_DATA = 'Delete Curated Data',
  FEEDS_NOTIFICATONS = 'Feeds Notificatons',
  CURATION_NOTIFICATONS = 'Curation Notificatons',
  PUBLISH_NOTIFICATONS = 'Publish Notificatons',
  SHOULD_NOT_GET_DASHBOARD = 'Should Not Get Dashboard',
  MIGRATE_CURATION = 'Migrate Curation',
  WHOLE_ENCHILADA = 'Whole Enchilada',
  VIEW_REPORTS = 'View Reports',
  RUN_REPORT = 'Run Report',
  REPORTING_NOTIFICATONS = 'Reporting Notificatons',
  GENERATE_VIEWS = 'Generate Views',
  GENERATE_CATEGORY_WHITELIST = 'Generate Category Whitelist',
  VIEW_GLOBAL_TAXONOMY = 'View Global Taxonomy',
  EDIT_GLOBAL_TAXONOMY = 'Edit Global Taxonomy',
  VIEW_GLOBAL_CLASSIFICATION_RULES = 'View Global Classification Rules',
  EDIT_GLOBAL_CLASSIFICATION_RULES = 'Edit Global Classification Rules',
  VIEW_CUSTOMER_STRATEGY = 'View Customer Strategy',
  EDIT_CUSTOMER_STRATEGY = 'Edit Customer Strategy',
  EDIT_CUSTOMER_STRATEGY_IN_PREVIEW = 'Edit Customer Strategy in Preview',
  APPROVE_CUSTOMER_STRATEGY = 'Approve Customer Strategy',
  EDIT_GUIDELINES_IN_CURATION = 'Edit Guidelines In Curation',
  VIEW_GUIDELINES = 'View Guidelines',
  EDIT_GUIDELINES = 'Edit Guidelines',
  VIEW_CURATION_JOBS = 'View Curation Jobs',
  MANAGE_CURATION_JOBS = 'Manage Curation Jobs',
  EDIT_CURATION_TASK_FIELDS = 'Edit Curation Task Fields',
  PERFORM_CURATION_TASKS = 'Perform Curation Tasks',
  PERFORM_QA_CURATION_TASKS = 'Perform QA Curation Tasks',
  USE_GLOBAL_TAXONOMY_FOR_PBJS = 'Use Global Taxonomy For PBJs',
  RECEIVE_CURATION_TASK_EMAILS = 'Receive Curation Task Emails',
  RECEIVE_QA_TASK_EMAILS = 'Receive QA Task Emails',
  RECEIVE_STRATEGY_APPROVAL_EMAILS = 'Receive Strategy Approval Emails',
  CHANGE_PRODUCT_BUCKET = 'Change Product Bucket',
  PREVIEW_CURATION_TASK = 'Preview Curation Task',
  MANAGE_CUSTOM_CURATION_QUEUES = 'Manage Custom Curation Queues',
  MANAGE_CURATION_RULES = 'Manage Curation Rules',
  VIEW_CURATION_PERFORMANCE = 'View Curation Performance',
  MANAGE_MACHINE_CURATION = 'Manage Machine Curation',
  VIEW_INSIGHTS = 'View Insights',
  VIEW_PRODUCT_PERFORMANCE = 'View Product Performance',
  VIEW_USAGE_DASHBOARD = 'View Usage Dashboard',
  VIEW_ATTRIBUTE_INTELLIGENCE = 'View Attribute Intelligence',
}



// WEBPACK FOOTER //
// ./src/app/resources/models/permission.enum.ts